export default "__VITE_ASSET__CM_uqWY8__"